import { axios } from "~/plugins/request"

export const state = () => {
	return {}
}
export const mutations = {}
export const actions = {
	selectFinanceAll({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`finance/selectFinanceAll`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  approveSalesOrderFinaceStart({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`order/approveSalesOrderFinaceStart`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  updateFinance({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.post(`finance/updateFinance`, params)
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  studentDelete({ commit }, params) {
		return new Promise((resolve, reject) => {
			axios.get(`student/studentDelete`, {params})
				.then(response => {
					resolve(response)
				})
				.catch(error => {
					reject(error)
				})
		})
  },
  intDictionary({ commit }, params) {
		return new Promise((resolve, reject) => {
			let  getGaokaoYear  = axios.get("/dictionary/findAllItemByTypeCode", {params: {typeCode: "gaokaoYear"}})
			Promise.all([getGaokaoYear])
			.then(res => {
				resolve(res)
			}).catch(error=> {
				console.log(error)
			}) 
		})
  },
}